// 화면 공통 로딩 상태 저장소 (스펙24)
// 데이터를 조회하는 동안 로딩박스를 표시하고, 표시하는 동안 뒤의 버튼은 못누르게 막는다.
import Vue from 'vue';

// 동시 요청 카운트 기반. 0보다 크면 로딩 중.
const state = Vue.observable({ count: 0 });

export function beginLoading() {
  state.count++;
}

export function endLoading() {
  state.count = Math.max(0, state.count - 1);
}

export function isLoading() {
  return state.count > 0;
}

export function loadingState() {
  return state;
}
